
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resorts/[[...page]]",
      function () {
        return require("private-next-pages/resorts/[[...page]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resorts/[[...page]]"])
      });
    }
  